// custom-popup.js - Monica Nov 13 2024

document.addEventListener('DOMContentLoaded', function () {
  // Only proceed if not on the homepage
  if (window.location.pathname === '/' || document.body.classList.contains('template-index')) {
    // Stop executing if it's the homepage
    console.log('Homepage detected - not adding popup to product images.')
    return
  }

  console.log('Custom Popup JS Loaded')

  // Selectors for main product images
  const productImages = document.querySelectorAll(
    '.product-media-main-wrapper img, .product-media img, modal-opener img, .no-js-hidden'
  )

  console.log(`Found ${productImages.length} product images.`)

  // Function to create and show the pop-up
  function showCustomPopup(e) {
    console.log('Right-click detected on image.')
    e.preventDefault() // Prevent the default context menu

    // Remove any existing custom pop-up
    let existingPopup = document.getElementById('custom-right-click-popup')
    if (existingPopup) {
      console.log('Existing pop-up found and removed.')
      existingPopup.remove()
    }

    // Create the pop-up container
    const popup = document.createElement('div')
    popup.id = 'custom-right-click-popup'
    popup.classList.add('custom-popup')

    // Populate the pop-up with the desired message and ARIA attributes for accessibility
    popup.innerHTML = `
            <div role="alert" aria-live="assertive">
                <p>mycybermarkets.com says "Sorry, our images are copyrighted."</p>
            </div>
        `

    // Append the pop-up to the body
    document.body.appendChild(popup)
    console.log('Pop-up created and appended to the DOM.')

    // Trigger CSS transition by adding the 'show' class
    requestAnimationFrame(() => {
      popup.classList.add('show')
    })

    // Set focus to the pop-up for accessibility
    popup.setAttribute('tabindex', '-1')
    popup.focus()

    // Hide the pop-up when clicking elsewhere
    document.addEventListener('click', function hidePopup(e) {
      if (!popup.contains(e.target)) {
        console.log('Click outside the pop-up detected, removing pop-up.')
        popup.remove()
        document.removeEventListener('click', hidePopup)
      }
    })

    // Allow closing the pop-up with the ESC key
    document.addEventListener('keydown', function escListener(e) {
      if (e.key === 'Escape') {
        console.log('ESC key pressed, removing pop-up.')
        popup.remove()
        document.removeEventListener('keydown', escListener)
      }
    })
  }

  // Attach event listeners to all product images
  productImages.forEach(function (image) {
    image.addEventListener('contextmenu', showCustomPopup)
    console.log('Event listener attached to image:', image.src)
  })
})
